import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { StyleProvider } from '@ant-design/cssinjs';
import "antd/dist/reset.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <StyleProvider >
        <App />
      </StyleProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
reportWebVitals();
